<template>
  <div>
    <d-card
      class="mb-5 has-box-show is-border-radius-10"
    >
      <d-card-row>
        <p class="has-text-weight-semibold mb-3 is-size-7 is-custom-grey">
          {{ $t('rent_agent_name') }}
        </p>
        <div class="is-flex is-justify-content-space-between is-align-items-center">
          <div class="left is-flex">
            <div
              v-if="rentAgents"
              class="is-flex gap-1 is-flex-wrap-wrap"
            >
              <span
                v-for="rent_agent in rentAgents"
                :key="rent_agent.id"
              >
                <b-tooltip
                  type="is-black"
                  position="is-right"
                  multilined
                >
                  <img
                    class="avatar is-30 is-avatar is-clickable"
                    :src="rent_agent.avatar_url"
                    :title="$t('see_agent_listings')"
                    @click="goToAgentListings(rent_agent)"
                  >

                  <template #content>
                    <div>
                      <p>
                        {{ rent_agent.name }}
                      </p>
                      <p>
                        {{ rent_agent.email }}
                      </p>
                      <p v-if="rent_agent.role =='employee'">
                        {{ $t("devloc_agent").capitalize() }}
                      </p>
                    </div>
                  </template>
                </b-tooltip>
              </span>
            </div>
          </div>
          <div class="right">
            <button
              type="button"
              class="button is-dark is-full-width button-cta"
              @click="isShownContactAgentModal = true"
            >
              {{ $t("contact_agent") }}
            </button>
          </div>
        </div>
      </d-card-row>
    </d-card>

    <contact-agents-modal
      v-model="isShownContactAgentModal"
      :property-id="propertyId"
    />
  </div>
</template>


<script>
import ContactAgentsModal from "../../components/ContactAgentsModal.vue";

export default {
  components: {
    "contact-agents-modal": ContactAgentsModal,
  },
  props: {
    rentAgents: {
      type: [Array, null],
      required: true,
    },
    propertyId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      isShownContactAgentModal: false,
    };
  },
  methods: {
    goToAgentListings(agent) {
      const slug = (agent.name || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");

      this.$router.push({ path: "/", query: { agent: slug } });
    },
  },
};
</script>
<style scoped>
   .avatar {
    border-radius: 1000px;
    height: 36px;
    width: 36px;
    margin-right: 0.5rem;
 }
</style>
